import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { Getter, Action, Mutation } from 'vuex-class'

@Component({})
export default class SearchBar extends Vue {
  
  // Actions
  @Action action_getProductsSuggestions
  @Action actoin_getProductsSearch
  @Action action_getCitiesInformation: any

  // Getters
  @Getter getProductsSuggestions: any
  @Getter getCity: any
  @Getter getCountry: any
  @Getter getOpenSearchBar;
  @Getter getIsUnderMobile;

  // Mutations
  @Mutation PRODUCTS_SUGGESTIONS: any
  @Mutation OPEN_SEARCH_BAR;
  @Mutation IS_SELECT_COUNTRY: any

  showInput = false;
  searchValue = "";
  showSuggestions = false;

  get getRawSearchSuggestion() {
    return `Buscar "${this.searchValue}"`;
  }

  _toggleSearchBar(value: boolean) {
    this.showInput = value;
    this.$emit('growSearchBar', value);
    this.$nextTick(() => {
      const element = document.getElementById('searchField');
      element.focus();
    })
  }

  _onCancelButtonPress() {
    this._toggleSearchBar(false);
    this.searchValue = "";
    this.$nextTick(() => {
      const element = document.getElementById('searchField');
      element.blur();
    });
    this.OPEN_SEARCH_BAR(false);
  }

  onInputFocus() {
    this.showSuggestions = true;
  }

  onInputBlur() {
    this.showSuggestions = false;
    this.OPEN_SEARCH_BAR(false);
  }


  get getCurrentCityFlagSrc() {
    if(this.getCity && this.getCity.id) {
      const cityId = this.getCity.id;
      let response = "/assets/images/banderas/";
      if(cityId === 3 || cityId === 4) {
        response += "co.svg";
      } else if(cityId === 5) {
        response += "mx.svg";
      } else {
        response += "co.svg";
      }
      return response;
    }
  }

  _country() {
    this.IS_SELECT_COUNTRY(false);
  }

  // Sub header
  _toggleModalCities() {
    this.IS_SELECT_COUNTRY(false)
  }
  

  @Watch('searchValue')
  async onTypeSomething() {
    this.OPEN_SEARCH_BAR(true);
    if(this.searchValue.length) {
      this.OPEN_SEARCH_BAR(true);
      const cityId = this.getCity.id;
      const payload = {
        cityId: cityId,
        searchValue: this.searchValue
      };
      await this.action_getProductsSuggestions(payload);
    } else {
      this.PRODUCTS_SUGGESTIONS([]);
      this.OPEN_SEARCH_BAR(false);
    }
  }

  onSearchValue() {
    if(this.searchValue.length) {
      if(this.$route.name && this.$route.name !== 'search') {
        this.$router.push({ name: 'search', query: { search: this.searchValue }});
      } else {
        if(this.$route.query && this.$route.query.search) {
          this.$router.replace({ query: {search: this.searchValue }})
        }
      }
      const searchField = document.getElementById('searchField');
      if(searchField) {
        searchField.blur();
      }
    }
  }

  onSuggestionClick(item) {
    if(item && item.id) {
      this.$router.push({ name: 'productDetail', params: { product_id: item.id } });
      this.PRODUCTS_SUGGESTIONS([]);
    }
  }
}